import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=1ddbcc7e&scoped=true&"
import script from "./notify.js?vue&type=script&lang=js&"
export * from "./notify.js?vue&type=script&lang=js&"
import style0 from "./notify.scss?vue&type=style&index=0&id=1ddbcc7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbcc7e",
  null
  
)

export default component.exports